document.addEventListener('DOMContentLoaded', function() {
  const tooltips = document.querySelectorAll('.js-tooltip');
  
  tooltips.forEach(tooltip => {
    const tooltipText = tooltip.querySelector('.js-tooltip-text');
    
    tooltip.addEventListener('mouseenter', () => {
      tooltipText.classList.add('show');
    });
    
    tooltip.addEventListener('mouseleave', () => {
      tooltipText.classList.remove('show');
    });
  });
});